import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../loading-service';

@Component({
  selector: 'loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent implements OnInit {

  bloqueada: boolean;
  constructor(private loadingService: LoadingService) { }

  ngOnInit() {
    // setTimeout() é um workaround para evitar ExpressionChangedAfterItHasBeenCheckedError no console
    this.loadingService.blockState$.subscribe(blockState => setTimeout(() => this.bloqueada = blockState));
  }
}
